// ------------------------------------------------------------------
// Speaker directory. Keyed by slug so sessions can reference speakers
// without duplicating their bio in every session entry.
// Placeholders are intentional — swap `bio` and `photo` per speaker.
// `photo: null` makes the SpeakerCard render an initials chip instead.
// ------------------------------------------------------------------
export const SPEAKERS = {
  "ashique-cs": {
    name: "Ashique CS",
    role: "Speaker",
    title: "Founder & CEO, [Company]",
    bio: "Placeholder bio. Will be replaced with a 2–3 sentence introduction covering the speaker's company, sector and what they bring to the panel.",
    photo: null,
  },
  "rahul-mamman": {
    name: "Rahul Mamman",
    role: "Speaker",
    title: "Director, [Family Business]",
    bio: "Placeholder bio. Will be replaced with a 2–3 sentence introduction covering the speaker's company, sector and what they bring to the panel.",
    photo: null,
  },
  "rameez": {
    name: "Rameez",
    role: "Moderator",
    title: "Yi Kozhikode",
    bio: "Placeholder bio for the session moderator.",
    photo: null,
  },
  "shahad-moideen": {
    name: "Shahad Moideen",
    role: "Speaker",
    title: "[Designation], [Company]",
    bio: "Placeholder bio. Will be replaced with a 2–3 sentence introduction covering the speaker's company, sector and what they bring to the panel.",
    photo: null,
  },
  "varghese-alukka": {
    name: "Varghese Alukka",
    role: "Speaker",
    title: "[Designation], Alukkas Group",
    bio: "Placeholder bio. Will be replaced with a 2–3 sentence introduction covering the speaker's company, sector and what they bring to the panel.",
    photo: null,
  },
  "shaan": {
    name: "Shaan",
    role: "Moderator",
    title: "Yi Kozhikode",
    bio: "Placeholder bio for the session moderator.",
    photo: null,
  },
  "parisons-family": {
    name: "Parisons Family",
    role: "Speakers",
    title: "Parisons Group",
    bio: "Placeholder bio. Will be replaced with a 2–3 sentence introduction covering the family's businesses and what they bring to the panel.",
    photo: null,
  },
  "sahal": {
    name: "Sahal",
    role: "Moderator",
    title: "Yi Kozhikode",
    bio: "Placeholder bio for the session moderator.",
    photo: null,
  },
};

// ------------------------------------------------------------------
// Family Business Conclave 2026 — content block driving:
//   - /events hub feature card
//   - /events/family-business-conclave detail page
//   - the Home banner
// ------------------------------------------------------------------
export const FAMILY_BUSINESS_CONCLAVE = {
  slug: "family-business-conclave",
  title: "Family Business Conclave 2026",
  tagline: "Legacy & Beyond",
  date: "30 May 2026",
  dateOverline: "Next event · 30 May 2026",
  venue: "KRS Hall, Kozhikode",
  // Landscape image used both as the detail-page hero and as the OG/Twitter
  // social preview for /events/* (until per-page meta is wired). Swap freely.
  heroImage:
    "https://images.unsplash.com/photo-1511578314322-379afb476865?w=1800&h=900&fit=crop&crop=entropy&cs=srgb&fm=jpg&q=80",
  about:
    "A day-long gathering for India's next generation of family-business leaders — Kozhikode edition. Four conversations on succession, scale, system-building and the long story arc of family enterprises. Lunch, networking and the Yi Kozhikode hospitality.",
  // Session order matches the agenda. `type: "break"` rows render as a tea
  // break divider. Other rows reference speaker slugs from SPEAKERS above.
  sessions: [
    {
      id: "s1",
      title: "Transforming and Scaling Family Enterprises",
      speakers: ["ashique-cs", "rahul-mamman"],
      moderator: "rameez",
    },
    {
      id: "s2",
      title: "Successor or System? What builds an enduring family business",
      speakers: ["shahad-moideen", "varghese-alukka"],
      moderator: "shaan",
    },
    { id: "break", type: "break", title: "Tea Break" },
    {
      id: "s3",
      title: "From Dinner Table to Boardroom: Conversations that build Empires",
      speakers: ["parisons-family"],
      moderator: "sahal",
    },
  ],
  // Edit names + INR prices when finalised. `priceINR: 0` renders as "Free".
  tiers: [
    {
      id: "student",
      label: "Student",
      priceINR: 0,
      description: "Verified college students — bring ID at the door.",
    },
    {
      id: "professional",
      label: "Professional",
      priceINR: 2500,
      description: "Working professionals, founders and chapter members.",
    },
    {
      id: "patron",
      label: "Patron",
      priceINR: 7500,
      description: "Premium seating, networking lunch and a copy of the conclave dossier.",
    },
  ],
};

// Convenience: array form for the EventsHub page (room for future events).
export const UPCOMING_EVENTS = [FAMILY_BUSINESS_CONCLAVE];

// Helper used by SpeakerCard / chips when photo is missing.
export function initialsOf(name) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("");
}

// Helper used by tier cards and the form.
export function formatINR(amount) {
  if (amount === 0) return "Free";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);
}
